import isEmpty from 'lodash/isEmpty';

function validateEmptyChecks(caseConf, nodeInfo) {
  const errors = [];
  const warnings = [];

  nodeInfo.checkNodes.forEach((checkNode) => {
    if (isEmpty(checkNode.data)) {
      warnings.push(emptyCheckWarning(checkNode.id));
    }
  });
  return {
    errors,
    warnings,
  };
}

function emptyCheckWarning(nodeId) {
  return {
    message: 'Check node has no conditions.',
    category: 'caseLogic',
    field: 'caseLogicDescription',
    id: nodeId,
    metadata: {
      nodeId: nodeId,
      scope: 'node',
      defaultVisibility: false,
    },
  };
}

export default validateEmptyChecks;